import Form, { InputType } from '../../lib/Formik';
import { OtpField, ResendOtp } from '../../lib/OtpField';
import en from '../../lang/en-us';
import { useFormik } from 'formik';

const { forgotPassword, verifyOtp, common, signupOtp } = en;

const formFields: Partial<InputType>[] = [
    {
        label: verifyOtp.registered,
        name: 'pan',
        type: 'text',
    },
    {
        component: OtpField,
        name: 'otp',
    },
];

const initialValues = {
    pan: '',
    otp: '',
};

export default function VerifyPassword(params: any) {
    const formik = useFormik({
        initialValues,
        onSubmit: () => { },
    });
    return (
        <div className="login-content border-card">
            <div className="login-content-inner">
                <a href="/forgot-password" className="back_btn">
                    <img src="/images/back-arrow.svg" alt="" aria-hidden="true" />
                    {common.back}
                </a>
                <h3 className="text-center">{verifyOtp.heading}</h3>
                <p className="otp-sent-info subheading">
                    {verifyOtp.otpinfo} <span>******6614</span>
                </p>
                <Form
                    ui={formFields}
                    submitButtonLabel={signupOtp.action.verifyOtp}
                    formik={formik}
                >
                    <ResendOtp />
                </Form>
            </div>
        </div>
    );
}
